import { render, staticRenderFns } from "./MovementsIcon.vue?vue&type=template&id=36f902ee&"
import script from "./MovementsIcon.vue?vue&type=script&lang=js&"
export * from "./MovementsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports